const EN_US = {
  'cashflowDomain.title': 'Cashflow',

  // Price Audit Landing Page
  'cashflowDomain.priceAudit.title': 'Price Audit',
  'cashflowDomain.priceAudit.cashflow.workflow.title': 'New Issues',
  'cashflowDomain.priceAudit.cashflow.escalated.workflow.title': 'New Escalated Issues',
  'cashflowDomain.priceAudit.refresh': 'Refresh',
  'cashflowDomain.priceAudit.startReviewing': 'Start Reviewing',
  'cashflowDomain.priceAudit.startReviewingEscalated': 'Start Reviewing Escalated',
  'cashflowDomain.priceAudit.errorTitle': 'Error',
  'cashflowDomain.priceAudit.errorBodyNoBatch': 'There are no audit batches to review',

  // Price Audit Details Page
  'cashflowDomain.priceAudit.details.page.error.audit.batch.not.found':
    'No audit batch found: {auditBatchUuid}',
  'cashflowDomain.priceAudit.details.page.error.no.access':
    'You do not have access to this audit batch: {auditBatchUuid}',
  'cashflowDomain.priceAudit.details.page.completed':
    'This audit batch has been reviewed. Would you like to review the next one?',
  'cashflowDomain.priceAudit.details.page.error.action.label.go.back': 'Go Back',
  'cashflowDomain.priceAudit.details.page.error.action.label.review.next': 'Review Next',
  'cashflowDomain.priceAudit.header.title': 'Issue #{auditBatchUuid}',
  'cashflowDomain.priceAudit.header.button.exit': 'Exit',
  'cashflowDomain.priceAudit.header.button.resolve': 'Resolve',
  'cashflowDomain.priceAudit.item.details.title.item.details': 'Item Details',
  'cashflowDomain.priceAudit.item.details.title.order.summary': 'Order Summary',
  'cashflowDomain.priceAudit.item.details.label.qty': 'Qty/wt.',
  'cashflowDomain.priceAudit.item.details.label.unit.price': 'Unit price',
  'cashflowDomain.priceAudit.item.details.label.store': 'Store',
  'cashflowDomain.priceAudit.item.details.label.order.created.at': 'Created at',
  'cashflowDomain.priceAudit.item.details.label.order.fulfilled.at': 'Delivered at',
  'cashflowDomain.priceAudit.item.details.label.order.id': 'Order id',
  'cashflowDomain.priceAudit.item.details.label.item.price.on.receipt': 'Item price on receipt',
  'cashflowDomain.priceAudit.item.details.label.overspend': 'Overspend',
  'cashflowDomain.priceAudit.priceComparison.table.noResults': 'No Price History Found',
  'cashflowDomain.priceAudit.priceComparison.table.title.catalog': 'Published Catalog Item History',
  'cashflowDomain.priceAudit.priceComparison.table.title.retailer': 'Data Sent from Retailer',
  'cashflowDomain.priceAudit.priceComparison.table.column.timestamp': 'Timestamp',
  'cashflowDomain.priceAudit.priceComparison.table.column.costUnit': 'Cost Unit',
  'cashflowDomain.priceAudit.priceComparison.table.column.price': 'Price',
  'cashflowDomain.priceAudit.priceComparison.table.column.loyaltyPrice': 'Loyalty Price (Dates)',
  'cashflowDomain.priceAudit.priceComparison.table.column.salePrice': 'Sale Price (Dates)',

  // Resolve Issue Modal Form
  'cashflowDomain.priceAudit.resolve.issue.form.title': 'Resolve Issue',

  'cashflowDomain.priceAudit.resolve.issue.form.label.discrepancy.type': 'Discrepancy Type',
  'cashflowDomain.priceAudit.resolve.issue.form.label.discrepancy.type.required':
    'Discrepancy type is required',
  'cashflowDomain.priceAudit.resolve.issue.form.label.correct.price': 'Correct Price',
  'cashflowDomain.priceAudit.resolve.issue.form.label.correct.price.required':
    'Correct price is required',
  'cashflowDomain.priceAudit.resolve.issue.form.label.notes': 'Notes',
  'cashflowDomain.priceAudit.resolve.issue.form.label.optional': ' (optional)',

  'cashflowDomain.priceAudit.resolve.issue.form.discrepancy.type.options.incorrect.price':
    'Incorrect Retailer Data: Incorrect (base/loyalty/sales) price provided',
  'cashflowDomain.priceAudit.resolve.issue.form.discrepancy.type.options.incorrect.cost.unit':
    'Incorrect Retailer Data: Incorrect cost unit provided',
  'cashflowDomain.priceAudit.resolve.issue.form.discrepancy.type.options.altered.by.catalog.processing':
    'Price Transformation Error: Correct price altered during catalog processing',
  'cashflowDomain.priceAudit.resolve.issue.form.discrepancy.type.options.incorrect.comparison.between.prices':
    'Price Mismatch: Incorrect comparison between loyalty, base, or sales prices',
  'cashflowDomain.priceAudit.resolve.issue.form.discrepancy.type.options.discrepancy.due.to.timing':
    'Outdated Retailer Data: Correct price, discrepancy due to timing between order placement and fulfillment',
  'cashflowDomain.priceAudit.resolve.issue.form.discrepancy.type.options.no.discrepancy':
    'No Discrepancy',
  'cashflowDomain.priceAudit.resolve.issue.form.submit.button': 'Submit and view next',
} as const

export default EN_US
